import React, { useState } from 'react';
import { useCurrentEditor } from '@tiptap/react';
import styles from './ImageGroup.module.scss';

const ImageGroup = () => {
  const { editor } = useCurrentEditor();
  const [isCreating, setIsCreating] = useState(false);

  const createImageGroup = () => {
    if (!editor) return;

    editor
      .chain()
      .focus()
      .insertImageGroup()
      .run();

    setIsCreating(true);
  };

  const addImageToGroup = (imageUrl, alt) => {
    if (!editor) return;

    editor
      .chain()
      .focus()
      .addImageToGroup({
        src: imageUrl,
        alt: alt || 'Image',
        class: 'tiptap-image',
        width: '100%',
        height: 'auto',
      })
      .run();
  };

  return (
    <div className={styles.imageGroupContainer}>
      <button
        onClick={createImageGroup}
        className={styles.createButton}
      >
        Create Image Group
      </button>
    </div>
  );
};

export default ImageGroup; 